module.exports = __webpack_public_path__ + "static/Malavan.636d13d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/Malavan.jpg
// module id = 1311
// module chunks = 137408898365125